(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FaxNumber', FaxNumber);

    FaxNumber.$inject = ['$resource'];

    function FaxNumber ($resource) {
        var resourceUrl =  'api/fax-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/fax-numbers/filter', method: 'GET', isArray: true},
            'orderFaxNumbers': {url: 'api/fax-numbers/order-fax-numbers', method: 'GET', isArray: true}
        });
    }
})();
